// @ts-ignore
export class ConfigItemOption {
    public key: string = '';
    public label: string = '';
  }
  
  export class ConfigItem {
    /**
     * 配置Key
     */
    public configKey: string = '';
    /**
     * 配置名称
     */
    public configName: string = '';
    /**
     * 必填项
     */
    public required: boolean = false;
    /**
     * 类型
     */
    public type?: string;
    /**
     * 选项列表
     */
    public options: ConfigItemOption[] = [];
  }
  
  export interface EnumDescription {
    key: string;
    value: string;
  }
  
  export class LaunchPlatform {
    public id: string = '';
    /**
     * 平台编码
     */
    public platformCode: string = '';
    /**
     * 平台名称
     */
    public platformName: string = '';
    /**
     * 配置列表
     */
    public configs: ConfigItem[] = [];
    /**
     * 是否允许授权
     */
    public allowAuth: boolean = false;
    /**
     * 授权链接模板
     */
    public authUrlTemplate?: string;
    /**
     * 拉取实例名称
     */
    public pullServiceName?: string;
    /**
     * 平台类型列表
     */
    public platformTypes?: string;
  }
  